const faqs = [
  {
    id: 1,
    heading: "What is interior design?",
    content:
      "Interior design is the art and science of enhancing the interior of a space to create a more aesthetically pleasing and functional environment. It involves selecting furniture, color schemes, lighting, and other elements to transform spaces.",
  },
  {
    id: 2,
    heading: "What services do you offer in architecture and design?",
    content:
      "Our architecture and design services encompass a wide range of offerings, including architectural planning, space optimization, interior design, 3D modeling, material selection, and project management. We provide comprehensive solutions for your design needs.",
  },
  {
    id: 3,
    heading: "How can I request your services?",
    content:
      "Requesting our architecture and design services is simple. Contact our team, discuss your project requirements, and we'll guide you through the process. We provide tailored solutions to bring your design visions to life.",
  },
  {
    id: 4,
    heading: "What are the benefits of professional interior design?",
    content:
      "Professional interior design enhances the functionality and aesthetics of your space. It can improve your quality of life, increase property value, and create a harmonious environment. Our expertise ensures your project's success.",
  },
  {
    id: 5,
    heading: "Why choose our architecture and design services?",
    content:
      "Our architecture and design team is dedicated to creating innovative and customized solutions. We prioritize client satisfaction, quality craftsmanship, and turning your design aspirations into reality. Choose us to elevate your spaces.",
  },
];

export default faqs;